export default __webpack_public_path__ + "static/media/RhymesWeather_05.58452ac4.png";